/**
 * Form state of KPI target fields: one text per KPI ("" = no target at this
 * level, the next one applies).
 */

import { KPIS, type Kpi, type KpiTargetValues } from '../../services/KpiTargetService';

export type TargetInputs = Record<Kpi, string>;

const PERCENT: Kpi[] = ['efficiency', 'utilization', 'rejectRatio'];

/** The texts of saved targets. */
export function toInputs(targets: KpiTargetValues | undefined): TargetInputs {
  const inputs = {} as TargetInputs;
  for (const kpi of KPIS) inputs[kpi] = targets?.[kpi] === undefined ? '' : String(targets[kpi]);
  return inputs;
}

/** The targets of the texts, or the first KPI whose value is not valid. */
export function parseInputs(inputs: TargetInputs): { targets: KpiTargetValues } | { invalid: Kpi } {
  const targets: KpiTargetValues = {};
  for (const kpi of KPIS) {
    const text = inputs[kpi].trim().replace(',', '.');
    if (!text) continue;
    const value = Number(text);
    const ok =
      Number.isFinite(value) &&
      (PERCENT.includes(kpi) ? value >= 0 && value <= 100 : kpi === 'minMTBF' ? value > 0 : value >= 0);
    if (!ok) return { invalid: kpi };
    targets[kpi] = value;
  }
  return { targets };
}
